var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Meal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 22.18V60c.005.05.005.1 0 .15a1.5 1.5 0 11-3 0V41h-3V22.13A3.051 3.051 0 0169.54 19 3.16 3.16 0 0172 22.18zM62.41 39.5a21 21 0 11-42 0 21 21 0 0142 0zm-4 0a17 17 0 10-34 0 17 17 0 0034 0zM15 34h-3V19H9v15H6V19H3v15a7.51 7.51 0 006 7.35V60a1.5 1.5 0 003 0V41.35A7.51 7.51 0 0018 34V19h-3v15z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Meal.d36f46b4.svg";
export { SvgF1Meal as ReactComponent };